export class RequestPreviewDto {
    allEmp: number;
    listEmp: any[];
    startDate: Date;
    endDate: Date;
    purposeType: any[];
    email: string;
    fullName: string;
    reportType: string;
    showdeclare: string;
}

export class RequestDownloadExcelDto {
    allEmp: number;
    listEmp: any[];
    startDate: Date;
    endDate: Date;
    purposeType: any[];
    email: string;
    fullName: string;
    reportType: string;
    showdeclare: string;
}

export class RequestDownloadPdfDto {
    allEmp: number;
    listEmp: any[];
    startDate: Date;
    endDate: Date;
    purposeType: any[];
    email: string;
    fullName: string;
    reportType: string;
    showdeclare: string;
}

export class RequestSendEmailExcelDto {
    allEmp: number;
    listEmp: any[];
    startDate: Date;
    endDate: Date;
    purposeType: any[];
    email: string;
    fullName: string;
    reportType: string;
    showdeclare: string;
}

export class ResponseSendEmailExcelDto {
    message: string;
    data?: any;
}

export class RequestSendEmailPdfDto {
    allEmp: number;
    listEmp: any[];
    startDate: Date;
    endDate: Date;
    purposeType: any[];
    email: string;
    fullName: string;
    reportType: string;
    showdeclare: string;
}

export class ResponseSendEmailPdfDto {
    message: string;
    data?: any;
}





// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/dto/business-trip-report.dto.ts